import PptxGen from 'pptxgenjs'

export default {
  async make (tickets, customers, name, urlImages) {
    const pptx = new PptxGen()
    pptx.setLayout('LAYOUT_4x3')

    pptx.defineSlideMaster(await this.getLayoutFirst(urlImages))
    pptx.defineSlideMaster(await this.getLayoutMaster(urlImages))

    const firstSlide = pptx.addNewSlide('FIRST_SLIDE')
    firstSlide.addText('CERIMÔNIA DE ENTREGA', { placeholder: 'title' })

    for (let id in tickets) {
      let uc = customers[tickets[id].customerId].uc
      let holder = customers[tickets[id].customerId].holder
      let cpf = customers[tickets[id].customerId].cpf

      const slide = pptx.addNewSlide('MASTER_SLIDE')
      slide.addText('UC: ' + uc, { placeholder: 'uc' })
      slide.addText(holder, { placeholder: 'holder' })
      slide.addText('CPF: ' + cpf, { placeholder: 'cpf' })
    }
    pptx.save(name)
  },
  async getLayoutFirst (urlImages) {
    const logoTermDelivery = await this.convertImgToBase64URL(urlImages.imgTermDelivery)
    const logoPresenter = await this.convertImgToBase64URL(urlImages.imgPresenterLeft)
    return {
      title: 'FIRST_SLIDE',
      bkgd: 'ffffff',
      // bkgd: {
      //   data: logoPresenter
      // },
      objects: [
        { 'image': { x: 1, y: 0.2, data: logoTermDelivery } },
        { 'image': { x: 8, y: 0.2, data: logoPresenter } },
        {
          'placeholder': {
            options: { name: 'title', type: 'text', x: 0, y: 3.4, w: '100%', fontSize: 36, align: 'center', color: '000000' },
            text: ''
          }
        }
      ]
    }
  },
  async getLayoutMaster (urlImages) {
    const logoTermDelivery = await this.convertImgToBase64URL(urlImages.imgTermDelivery)
    const logoPresenter = await this.convertImgToBase64URL(urlImages.imgPresenterLeft)
    return {
      title: 'MASTER_SLIDE',
      bkgd: 'ffffff',
      // bkgd: {
      //   data: logoPresenter
      // },
      objects: [
        { 'rect': { x: 0, y: 1.4, w: '100%', h: 7, fill: 'eff3f6' } },
        { 'rect': { x: 0.5, y: 3, w: '90%', h: 1, fill: '5abfa7' } },
        { 'rect': { x: 2.5, y: 4, w: '50%', h: 1, fill: 'ffffff' } },
        { 'image': { x: 1, y: 0.2, data: logoTermDelivery } },
        { 'image': { x: 8, y: 0.2, data: logoPresenter } },
        { 'image': { x: 8, y: 6, w: 1, h: 1.3, path: 'static/img/selo.png' } },
        {
          'placeholder': {
            options: { name: 'holder', type: 'text', x: 0, y: 3.3, w: '100%', fontSize: 22, align: 'center', color: 'ffffff', bold: true },
            text: ''
          }
        },
        {
          'placeholder': {
            options: { name: 'uc', type: 'text', x: 0, y: 4.2, w: '100%', fontSize: 18, align: 'center', color: '000000' },
            text: ''
          }
        },
        {
          'placeholder': {
            options: { name: 'cpf', type: 'text', x: 0, y: 4.5, w: '100%', fontSize: 18, align: 'center', color: '000000' },
            text: ''
          }
        }
      ]
    }
  },
  convertImgToBase64URL (url, outputFormat) {
    return new Promise((resolve, reject) => {
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        var canvas = document.createElement('CANVAS')
        var ctx = canvas.getContext('2d')
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL(outputFormat)
        resolve(dataURL)
        canvas = null
      }
      img.src = url
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/PptPresenter.js